import { z } from 'zod';

import {
    useNameZodSchema,
    useSplitDobZodSchema,
} from '@myphx-engineering/phx-design-system/hooks';

export const useVerifyFormSchema = () => {
    const { fields, superRefine } = useSplitDobZodSchema(false);

    return z
        .object({
            firstName: useNameZodSchema(),
            lastName: useNameZodSchema(),
            ...fields,
            attest: z.boolean().refine((val) => val === true),
        })
        .superRefine(superRefine);
};
